<template>
  <h3>{{ messages.tableHead[store.langSelect.value] }} {{ account }}</h3>
  <div class="mytable">
    <div v-show="account" class="table">
      <div class="thead">
        <div class="tr">
          <slot name="mtthead"></slot>
          <!--      <div class="th">Date</div>
          <div class="th" style="width: 500px">Description</div>
          <div class="th">To</div> -->
        </div>
      </div>
      <div class="tbody">
        <template v-for="(item, i) in trades" :key="i">
          <slot v-bind:item="item" name="mttbody"></slot>

          <!-- <div class="tr"  v-if="item.src===src ">
             <div class="td">{{ getStringTime(item.m) }}</div>
              <div class="td">{{ item.desc }}</div>
             <div class="td">{{ item.crd }}</div>

           </div>-->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, watch } from "vue";
import { useMyStorage } from "@/store/global";

export default {
  name: "MoneyTransactionHistoryTable",
  props: ["account", "src"],

  setup(props) {
    const store = useMyStorage();
    const trades = reactive(store.MoneyTransaction[props.account]);
    console.log(trades);

    watch(
      () => props.account,
      (v) => {
        if (v !== "") {
                   
          trades.value = store.MoneyTransaction[v];
          console.log(trades)

        }
      },
      { deep: true }
    );
    /*   watch(positions_info, (nV) => {
         if (nV.value.length > 2) {
           posMin.value = false
         } else {
           posMin.value = true
         }

       })*/
    const getStringTime = (val) => {
      // console.log("++++++++++"+val+"----------")
      if (val < 2613553314) {
        let ts = new Date(val * 1000);
        return (
          pad(ts.getUTCDate()) +
          "/" +
          pad(ts.getUTCMonth() + 1) +
          "/" +
          ts.getUTCFullYear() +
          " " +
          pad(ts.getUTCHours()) +
          ":" +
          pad(ts.getUTCMinutes()) +
          ":" +
          pad(ts.getUTCSeconds())
        );
      }
      return "";
    };
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    };

    /*  getHistory()
    setInterval(()=>{
      getHistory()
    },30000)*/
    const messages = {
      tableHead: ["История операций по", "History of transactions on account"],
    };
    return {
      messages,
      getStringTime,
      store,
      trades,
    };
  },
};
</script>

<style>
.table {
  margin-top: 4px;
  width: 100%;
  display: table;
  table-layout: fixed;
  /*min-height: 80px;*/
}

.vmiddle {
  vertical-align: middle;
}

.thead {
  font-family: Proxima Nova Condensed;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 17px;
  color: #777777;
  width: 100%;
  padding-bottom: 4px;
  height: 17px;
  display: table-header-group;
}

.thead .tr .th {
  border-bottom: 1px solid #e82862;
  text-align: center;
}

.tr {
  display: table-row;
  width: 100%;
}

.cel,
.col,
.td,
.th {
  display: table-cell;
  width: 100%;
  padding: 2px 0px;
}

.tbody .tr .td {
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
}

.tbody {
  display: table-row-group;
}

.tbody .tr:nth-child(odd) {
  background-color: #f7f7f7;
}
</style>
